import React from 'react';

import styled from '@emotion/styled';

import useSetLookupPrice from '../../../../hooks/dashboard/driver-lookup/useSetLookupPrice';
import { LookupPriceInitialValues } from '../../../../models/dashboard/driver-lookup/lookup-price';
import { useAppSelector } from '../../../../redux/store';
import { ModalContext } from '../../ModalContext';
import TriggerBundlePaymentForm from './TriggerBundlePaymentForm';
import TriggerRegularPricePaymentForm from './TriggerRegularPricePaymentForm';

interface TriggerPaymentForPaymentKindProps {
  modalTitle: string;
}

const TriggerPaymentForPaymentKind: React.FC<
  TriggerPaymentForPaymentKindProps
> = ({ modalTitle }) => {
  const { lookupConfig } = useAppSelector((state) => state.lookupConfigData);
  const { setLookupPrice, loading } = useSetLookupPrice();
  const [amount, setAmount] = React.useState(0);
  const modalContext = React.useContext<any>(ModalContext);
  const price: number = lookupConfig?.unitPrice ?? 0;

  const handleAmountFieldChange = (unit: string) => {
    setAmount(Number(unit ?? 0) * price);
  };

  const handleOnSubmit = (value: any, typeOfPayment: string, actions: any) => {
    let data: Record<string, any> =
      typeOfPayment === 'Single'
        ? { quantity: value.amount, purchaseType: 'DirectUnits' }
        : {
            bundle: value.amount,
            purchaseType: 'Bundle',
          };

    let callbackUrl;

    if (window.location.origin.includes('localhost')) {
      callbackUrl = `https://dev-app.logirate.org/payment-successful`;
    } else {
      callbackUrl = `${window.location.origin}/payment-successful`;
    }

    setLookupPrice(
      {
        ...data,
        callbackUrl,
      },
      () => {
        actions.resetForm(LookupPriceInitialValues);
        modalContext?.setShowModal(false);
      },
    );
  };

  return (
    <Container>
      {modalTitle === 'Single Look-up' && (
        <TriggerRegularPricePaymentForm
          handleOnSubmit={(values, actions) =>
            handleOnSubmit(values, 'Single', actions)
          }
          handleAmountFieldChange={handleAmountFieldChange}
          loading={loading}
          amount={amount}
          price={price}
        />
      )}

      {modalTitle === 'Bundle Look-ups' && (
        <TriggerBundlePaymentForm
          handleOnSubmit={(values, actions) =>
            handleOnSubmit(values, 'Bundle', actions)
          }
          handleAmountFieldChange={handleAmountFieldChange}
          loading={loading}
          amount={amount}
          price={price}
        />
      )}
    </Container>
  );
};

export default TriggerPaymentForPaymentKind;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
